import React from "react";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";
import { ClearIcon } from "@mui/x-date-pickers";

const boxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "8px",
};

const DisclaimerModal = ({ open, onClose }) => (
  <Modal open={open} onClose={onClose} aria-labelledby="disclaimer-title">
    <div className="vrufyerv">
      <Box
        sx={boxStyle}
        style={{
          width: "50%",
          overflowY: "auto",
        }}
      >
        <p className="cross-people-req-model-disclaimer">
          <ClearIcon onClick={onClose} />
        </p>
        <div className="disclaimer-modal">
          <div className="disclaimer-content">
            <h2>Disclaimers</h2>
            <div className="disclaimer-section">
              <h3>1. Legal or Contractual Authority</h3>
              <ul>
                <li>Orbit Intel Chat responses are not legally binding, and do not constitute or convey legal advice. You should not act upon any Orbit Intel Chat responses or information without first seeking qualified professional guidance from Orbit's legal counsel on your specific question or matter.</li>
              </ul>
            </div>
            <div className="disclaimer-section">
              <h3>2. Accuracy & Reliability</h3>
              <ul>
                <li>Orbit Intel Chat responses are generated based on available data and programmed logic. While we strive for accuracy, we cannot guarantee that all information is complete, correct, or up to date.</li>
                <li>Users should verify any information provided by Orbit Intel Chat before relying on its output.</li>
              </ul>
            </div>
            <div className="disclaimer-section">
              <h3>3. IT & Security Disclaimer</h3>
              <ul>
                <li>Use of Orbit Intel Chat is subject to Orbit's IT Usage and AI Governance policies and processes. Misuse may result in access restrictions or disciplinary action.</li>
                <li>Users should review for any content produced by Orbit Intel Chat remains a critical security measure.</li>
              </ul>
            </div>
            <div className="disclaimer-section">
              <h3>4. HR Authority</h3>
              <ul>
                <li>Orbit Intel Chat does not replace or take precedence over official Human Resources communications, employee handbooks, or direct guidance from Human Resources staff.</li>
                <li>Do not use Orbit Intel Chat for issues involving workplace disputes, disciplinary matters, or sensitive personal circumstances. Users should contact HR directly.</li>
              </ul>
            </div>
            <div className="disclaimer-section">
              <h3>5. Confidentiality & Data Handling</h3>
              <ul>
                <li>In compliance with the Standard of Conduct, do not share sensitive personal or confidential company information with Orbit Intel Chat.</li>
              </ul>
            </div>
            <div className="disclaimer-section">
              <h3>6. Compliance & Policy Alignment</h3>
              <ul>
                <li>Orbit Intel Chat does not replace or take precedence over Orbit's policies, processes, or compliance requirements.</li>
              </ul>
            </div>
          </div>
        </div>
      </Box>
    </div>
  </Modal>
);

export default DisclaimerModal;
